 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"announcements":"announcements","announcements/details":"announcements/details","announcements/home":"announcements/home","config":"config","crafting/generators":"crafting/generators","crafting/items":"crafting/items","crafting/tasks":"crafting/tasks","epics":"epics","epics/details":"epics/details","feats":"feats","feats/details":"feats/details","forums/details":"forums/details","forums/downloads":"forums/downloads","forums/home":"forums/home","forums/topic":"forums/topic","forums/unapproved":"forums/unapproved","furniture":"furniture","furniture-sales":"furniture-sales","furniture/details":"furniture/details","patreon/logs":"patreon/logs","patreon/salaries":"patreon/salaries","patreon/unsynced":"patreon/unsynced","quests":"quests","quests/create":"quests/create","quests/details":"quests/details","stories":"stories","stories/details":"stories/details","tools":"tools","transactions":"transactions","users/details":"users/details","users/home":"users/home"}[chunkId]||chunkId) + "." + {"announcements":"3bf66cd5","announcements/details":"f34f7967","announcements/home":"fbfb8e37","config":"96e71d85","crafting/generators":"67830f5f","crafting/items":"c60725f3","crafting/tasks":"53162d66","epics":"4e11b356","epics/details":"0ac3d98b","feats":"3399cd18","feats/details":"7d8e994a","forums/details":"c4af0f6e","forums/downloads":"1825b28a","forums/home":"38313fda","forums/topic":"cf3ab158","forums/unapproved":"e54fc362","furniture":"f5b81959","furniture-sales":"3fbc55f5","furniture/details":"86ca4ae1","patreon/logs":"3ac8abb7","patreon/salaries":"4a47794e","patreon/unsynced":"2e1a69f3","quests":"eb919d1d","quests/create":"b1c271cf","quests/details":"8ea04cad","stories":"53b2f4a7","stories/details":"621797ae","tools":"79730348","transactions":"74f00a58","users/details":"9858f4f7","users/home":"e7ca8b1f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"announcements/home":1,"crafting/generators":1,"crafting/items":1,"crafting/tasks":1,"epics":1,"epics/details":1,"feats":1,"feats/details":1,"forums/details":1,"forums/home":1,"forums/topic":1,"forums/unapproved":1,"furniture":1,"furniture-sales":1,"furniture/details":1,"patreon/logs":1,"patreon/salaries":1,"patreon/unsynced":1,"quests":1,"quests/details":1,"stories":1,"transactions":1,"users/details":1,"users/home":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"announcements":"announcements","announcements/details":"announcements/details","announcements/home":"announcements/home","config":"config","crafting/generators":"crafting/generators","crafting/items":"crafting/items","crafting/tasks":"crafting/tasks","epics":"epics","epics/details":"epics/details","feats":"feats","feats/details":"feats/details","forums/details":"forums/details","forums/downloads":"forums/downloads","forums/home":"forums/home","forums/topic":"forums/topic","forums/unapproved":"forums/unapproved","furniture":"furniture","furniture-sales":"furniture-sales","furniture/details":"furniture/details","patreon/logs":"patreon/logs","patreon/salaries":"patreon/salaries","patreon/unsynced":"patreon/unsynced","quests":"quests","quests/create":"quests/create","quests/details":"quests/details","stories":"stories","stories/details":"stories/details","tools":"tools","transactions":"transactions","users/details":"users/details","users/home":"users/home"}[chunkId]||chunkId) + "." + {"announcements":"31d6cfe0","announcements/details":"31d6cfe0","announcements/home":"83f57d39","config":"31d6cfe0","crafting/generators":"6ea6337b","crafting/items":"6ea6337b","crafting/tasks":"6ea6337b","epics":"5421e6a6","epics/details":"c9bef392","feats":"834d4b8e","feats/details":"c9bef392","forums/details":"83f57d39","forums/downloads":"31d6cfe0","forums/home":"83f57d39","forums/topic":"60d42af8","forums/unapproved":"1c4b4c1a","furniture":"6ea6337b","furniture-sales":"5421e6a6","furniture/details":"b57945c9","patreon/logs":"9f289cfd","patreon/salaries":"9f289cfd","patreon/unsynced":"5421e6a6","quests":"5421e6a6","quests/create":"31d6cfe0","quests/details":"c6408a5f","stories":"5421e6a6","stories/details":"31d6cfe0","tools":"31d6cfe0","transactions":"9f289cfd","users/details":"045ebbce","users/home":"5421e6a6"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
